import { render, staticRenderFns } from "./comparison-section.vue?vue&type=template&id=f64c2dbe&scoped=true"
import script from "./comparison-section.vue?vue&type=script&lang=js"
export * from "./comparison-section.vue?vue&type=script&lang=js"
import style0 from "./comparison-section.vue?vue&type=style&index=0&id=f64c2dbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f64c2dbe",
  null
  
)

export default component.exports